import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SD",
  "use": "SD-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"SD\"><path d=\"M699.68 512c0-169.935-137.76-307.695-307.695-307.695V32c265.095 0 480 214.905 480 480 0 265.095-214.905 480-480 480V819.695c169.935 0 307.695-137.76 307.695-307.695z\" fill=\"#1B1B1B\" p-id=\"68668\" /><path d=\"M152 512.51a240 240 0 1 0 480 0 240 240 0 1 0-480 0Z\" fill=\"#82BF54\" p-id=\"68669\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol